export const PrinterDPIs = [200, 300];
export const PrintAlignments = ['left', 'center', 'right'];
export const PrinterFonts = ['A', 'B'];
export const BarcodeTextPlacements = ['none', 'above', 'below', 'both'];
export const BarcodeTypes = ['UPC_A', 'EAN8', 'EAN13', 'CODE39', 'ITF', 'CODABAR', 'CODE128'];
export const DataCodeTypes = ['QR', ...BarcodeTypes];
//# sourceMappingURL=definitions.js.map